import React from 'react'
import { useHistory } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { GoogleIcon } from '@mote/assets/icons'
import { Block, Button, H3, P, Text } from '@mote/ui'
import { AuthLayout } from '../../layouts'
import IllustrationSVG from './assets/sign-up.svg'

export const AuthForm = ({ data }) => {
  const history = useHistory()
  const { title, subtitle, caption, isSignupPage, cta, redirect } = data
  return (
    <Block layout='horizontal' spreadX spreadY>
      <StyledAuthLayout isSignupPage={isSignupPage}>
        <Root
          layout='vertical'
          align='center'
          justify='center'
          gap={24}
          spreadX
        >
          <H3 color='#25252D' fontWeight={700} fontSize={28} lineHeight='120%'>
            {title}
          </H3>

          <P
            color='#6C6C84'
            alignment='center'
            fontWeight='normal'
            fontSize={15}
            lineHeight='140%'
            styles={{ maxWidth: '360px' }}
          >
            {subtitle}
          </P>

          <GoogleBtn
            icon={<GoogleIcon />}
            text={cta.text}
            size='lg'
            variant='secondary'
            onClick={cta.action}
          />

          {isSignupPage && (
            <Text
              tag='small'
              color='#6C6C84'
              fontWeight={400}
              fontSize={15}
              lineHeight='140%'
            >
              No card required
            </Text>
          )}

          <Text
            tag='small'
            alignment='center'
            lineHeight='140%'
            fontSize={15}
            color='#25252D'
          >
            {caption}{' '}
            <RedirectLink
              tag='a'
              variant='link'
              text={redirect.text}
              onClick={() => history.push(redirect.urlPath)}
            />
          </Text>
        </Root>
      </StyledAuthLayout>
      {isSignupPage && <Illustration />}
    </Block>
  )
}

const Illustration = () => {
  return (
    <IllustrationRoot layout='vertical' justify='center'>
      <object type='image/svg+xml' data={IllustrationSVG}>
        Mote Preview
      </object>
    </IllustrationRoot>
  )
}

const StyledAuthLayout = styled(AuthLayout)`
  ${({ isSignupPage }) =>
    isSignupPage &&
    css`
      width: 60%;

      @media (max-width: 991px) {
        width: 100%;
      }
    `}
`

const Root = styled(Block)`
  max-width: 600px;
`

const IllustrationRoot = styled(Block)`
  height: 100%;
  min-width: 40%;
  background: #faf2fd;
  padding: 96px 0 96px 71px;
  overflow: hidden;

  object {
    height: 100%;
  }

  @media (max-width: 991px) {
    display: none;
  }
`

const GoogleBtn = styled(Button)`
  padding: 0 60px;
  border-color: #d1d1e0;

  &:hover {
    border-color: #b2b2cc;
  }

  &:active {
    border-color: #ac0ae8;
  }

  span {
    font-size: 15px;
  }

  .button-icon {
    margin-right: 10px;
    height: 23px;
    width: 22px;
  }

  &[disabled] {
    opacity: 1;
    border-color: #bfb8cc;

    span {
      color: #bfb8cc;
    }

    svg {
      path {
        fill: #bfb8cc;
      }
    }
  }
`

const RedirectLink = styled(Button)`
  span {
    line-height: 140%;
  }
`
